export const MODAL = {
  EXPORT: 'export',
  NEW_SHIPMENT: 'newShipment',
  ADD_SERVICE_COMMENT: 'addServiceComment',
  MISSED_ITEM: 'missedItem',
  NEW_ITEM: 'newItem',
  ADD_SHIPMENT_DATA: 'addShipmentData'
};
